<template>
	<DaModalFrame v-model:open="modalIsOpen">
		<InsufficientFunds
			v-if="modalType === modalTypes.INSUFFICIENT_FUNDS"
			@close="modalIsOpen = false"
		/>
	</DaModalFrame>
	<div class="fixed inset-y-0 right-0 flex side-over z-50 w-sideover">
		<div class="h-full w-full flex flex-col bg-white shadow-xl">
			<div class="px-6 py-8 bg-blue-50">
				<div class="flex items-start justify-between">
					<div class="flex items-center gap-2">
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clip-path="url(#clip0_35403_96867)">
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M4.5012 3.94933V2.984C4.50121 2.84392 4.47362 2.70522 4.42001 2.5758C4.36641 2.44638 4.28784 2.32879 4.18879 2.22974C4.08974 2.1307 3.97215 2.05212 3.84273 1.99852C3.71332 1.94492 3.57461 1.91733 3.43453 1.91733H2.13316C2.13317 1.40882 2.33518 0.921144 2.69475 0.561575C3.05433 0.202006 3.54201 2.12165e-06 4.05052 0H21.5492C21.801 0 22.0503 0.049594 22.2829 0.145949C22.5155 0.242305 22.7269 0.383535 22.9049 0.561576C23.083 0.739617 23.2242 0.950982 23.3206 1.1836C23.4169 1.41623 23.4665 1.66555 23.4665 1.91733V22.0827C23.4665 22.3345 23.4169 22.5838 23.3206 22.8164C23.2242 23.049 23.083 23.2604 22.9049 23.4384C22.7269 23.6165 22.5155 23.7577 22.2829 23.8541C22.0503 23.9504 21.801 24 21.5492 24H4.05052C3.54201 24 3.05433 23.798 2.69475 23.4384C2.33518 23.0789 2.13317 22.5912 2.13316 22.0827H3.43453C3.57461 22.0827 3.71331 22.0551 3.84273 22.0015C3.97214 21.9479 4.08973 21.8693 4.18878 21.7703C4.28783 21.6712 4.3664 21.5536 4.42001 21.4242C4.47361 21.2948 4.5012 21.1561 4.5012 21.016V20.0507C4.5012 19.9106 4.47361 19.7719 4.42001 19.6425C4.3664 19.5131 4.28783 19.3955 4.18878 19.2964C4.08973 19.1974 3.97214 19.1188 3.84273 19.0652C3.71331 19.0116 3.57461 18.984 3.43453 18.984H2.13316V17.816H3.43453C3.57461 17.816 3.71331 17.7884 3.84273 17.7348C3.97214 17.6812 4.08973 17.6026 4.18878 17.5036C4.28783 17.4045 4.3664 17.2869 4.42001 17.1575C4.47361 17.0281 4.5012 16.8894 4.5012 16.7493V15.784C4.5012 15.6439 4.47361 15.5052 4.42001 15.3758C4.3664 15.2464 4.28783 15.1288 4.18878 15.0297C4.08973 14.9307 3.97214 14.8521 3.84273 14.7985C3.71331 14.7449 3.57461 14.7173 3.43453 14.7173H2.13316V13.5493H3.43453C3.57461 13.5493 3.71331 13.5217 3.84273 13.4681C3.97214 13.4145 4.08973 13.336 4.18878 13.2369C4.28783 13.1379 4.3664 13.0203 4.42001 12.8909C4.47361 12.7615 4.5012 12.6227 4.5012 12.4827V11.5173C4.5012 11.3773 4.47361 11.2386 4.42001 11.1091C4.3664 10.9797 4.28783 10.8621 4.18878 10.7631C4.08973 10.664 3.97214 10.5855 3.84273 10.5319C3.71331 10.4783 3.57461 10.4507 3.43453 10.4507H2.13316V9.28267H3.43453C3.57461 9.28267 3.71331 9.25508 3.84273 9.20148C3.97214 9.14787 4.08973 9.0693 4.18878 8.97025C4.28783 8.8712 4.3664 8.75362 4.42001 8.6242C4.47361 8.49478 4.5012 8.35608 4.5012 8.216V7.25067C4.5012 7.11059 4.47361 6.97188 4.42001 6.84247C4.3664 6.71305 4.28783 6.59546 4.18878 6.49641C4.08973 6.39736 3.97214 6.31879 3.84273 6.26519C3.71331 6.21159 3.57461 6.184 3.43453 6.184H2.13316V5.016H3.43454C3.57461 5.016 3.71332 4.98841 3.84273 4.93481C3.97215 4.88121 4.08974 4.80264 4.18879 4.70359C4.28784 4.60454 4.36641 4.48695 4.42001 4.35753C4.47362 4.22812 4.50121 4.08941 4.5012 3.94933ZM3.43574 2.71777H0.800358C0.653082 2.71777 0.533691 2.83716 0.533691 2.98444V3.94897C0.533691 4.09625 0.653082 4.21564 0.800358 4.21564H3.43574C3.58302 4.21564 3.70241 4.09625 3.70241 3.94897V2.98444C3.70241 2.83716 3.58302 2.71777 3.43574 2.71777ZM0.800358 11.2511H3.43574C3.58302 11.2511 3.70241 11.3705 3.70241 11.5178V12.4823C3.70241 12.6296 3.58302 12.749 3.43574 12.749H0.800358C0.653082 12.749 0.533691 12.6296 0.533691 12.4823V11.5178C0.533691 11.3705 0.653082 11.2511 0.800358 11.2511ZM3.43574 6.98444H0.800358C0.653082 6.98444 0.533691 7.10383 0.533691 7.25111V8.21564C0.533691 8.36292 0.653082 8.48231 0.800358 8.48231H3.43574C3.58302 8.48231 3.70241 8.36292 3.70241 8.21564V7.25111C3.70241 7.10383 3.58302 6.98444 3.43574 6.98444ZM3.43574 15.5178H0.800358C0.653082 15.5178 0.533691 15.6372 0.533691 15.7844V16.749C0.533691 16.8962 0.653082 17.0156 0.800358 17.0156H3.43574C3.58302 17.0156 3.70241 16.8962 3.70241 16.749V15.7844C3.70241 15.6372 3.58302 15.5178 3.43574 15.5178ZM3.43574 19.7844H0.800358C0.653082 19.7844 0.533691 19.9038 0.533691 20.0511V21.0156C0.533691 21.1629 0.653082 21.2823 0.800358 21.2823H3.43574C3.58302 21.2823 3.70241 21.1629 3.70241 21.0156V20.0511C3.70241 19.9038 3.58302 19.7844 3.43574 19.7844ZM19.3952 9.01637L18.306 10.1056C17.0919 9.43138 16.0901 8.43747 15.4063 7.23982L16.5125 6.13363C16.5377 6.10842 16.5503 6.09581 16.5611 6.08531C17.337 5.33248 18.5707 5.33248 19.3466 6.08531C19.3574 6.09581 19.37 6.10842 19.3952 6.13363C19.4204 6.15885 19.433 6.17145 19.4435 6.18228C20.1964 6.95816 20.1964 8.19184 19.4435 8.96773C19.4331 8.97854 19.4205 8.99112 19.3953 9.01626L19.3952 9.01637ZM9.44134 13.2048L13.9515 8.69458C14.6976 9.84449 15.6846 10.8249 16.8475 11.5641L12.3241 16.0875L12.324 16.0876L12.324 16.0876C11.899 16.5126 11.6865 16.7251 11.4254 16.8648C11.1643 17.0046 10.8696 17.0635 10.2801 17.1814L10.2801 17.1814L8.59971 17.5175L8.59969 17.5175C8.26709 17.584 8.10079 17.6173 8.00619 17.5227C7.91158 17.4281 7.94484 17.2618 8.01136 16.9291L8.34744 15.2487C8.46533 14.6593 8.52428 14.3646 8.66401 14.1035C8.80375 13.8424 9.01628 13.6298 9.44134 13.2048Z"
									fill="#94A3B8"
								/>
							</g>
							<defs>
								<clipPath id="clip0_35403_96867">
									<rect width="24" height="24" fill="white" />
								</clipPath>
							</defs>
						</svg>
						<div class="text-4xl font-bold text-neutral-700 ml-1.5">
							Nhận xét chung
						</div>
					</div>
					<div class="ml-3 h-7 flex items-center">
						<button
							type="button"
							class="
								rounded-md
								text-neutral-400
								hover:text-neutral-700
							"
							@click="$emit('close')"
						>
							<span class="sr-only">Close panel</span>
							<svg
								class="h-6 w-6"
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
								aria-hidden="true"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M6 18L18 6M6 6l12 12"
								/>
							</svg>
						</button>
					</div>
				</div>
			</div>
			<div class="pt-6 relative flex-1 px-4 sm:px-6 overflow-y-auto">
				<div class="flex items-center justify-between md-down:block">
					<div>
						<div class="font-semibold text-neutral-700">
							{{
								studentId
									? 'Nhận xét chung/ lưu ý cho phụ huynh'
									: 'Nhận xét chung/ lưu ý cho cấp quản lý'
							}}
						</div>
						<div class="text-xs text-neutral-400">
							*Luca AI có thể mắc lỗi, bạn hãy kiểm tra kỹ trước
							khi hoàn thành báo cáo
						</div>
					</div>
					<div class="md-down:flex md-down:justify-end">
						<button
							v-if="enableAiButton"
							class="
								luca-button
								flex
								items-center
								gap-1
								md-down:flex-end
							"
							:class="{ 'disable-button': disableAi }"
							@click="generateNote"
						>
							<div>Luca AI</div>
							<img
								v-if="disableAi"
								src="@/assets/images/icons/disable-coin.png"
								alt=""
							/>
							<img
								v-else
								class="w-4 h-4"
								src="@/assets/images/icons/coin.png"
								alt=""
							/>
							<div>{{ aiCost }}</div>
						</button>
					</div>
				</div>

				<div
					class="
						pt-6
						flex flex-nowrap
						items-center
						justify-center
						relative
					"
				>
					<div v-if="loadingInput" class="z-10 absolute">
						<Loading />
					</div>
					<textarea
						v-model="displayNote"
						:placeholder="
							monthly
								? 'Nhận xét chung của cả tháng'
								: 'Nhận xét chung của cả tuần'
						"
						class="note"
					></textarea>
				</div>
			</div>
			<div class="px-6 py-4 border-t border-yellow-50">
				<div class="flex justify-end">
					<button
						:disabled="!note"
						class="button-p text-center whitespace-nowrap w-fit"
						type="button"
						@click="$emit('submit', note)"
					>
						Xác nhận
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, computed, defineProps, watch, onUnmounted } from 'vue';
import { $api } from '@/services';
import Loading from '@/components/common/Loading.vue';
import { useStore } from 'vuex';
import { _var } from '@/enums/Common';
import InsufficientFunds from '@/components/elements/funds/InsufficientFunds.vue';
import { _MODAL_TYPE } from '@/enums';

const props = defineProps([
	'noteContent',
	'sideOverShow',
	'groupClassId',
	'reportId',
	'studentId',
	'monthly',
]);

const store = useStore();

const disableAi = ref(false);
const loadingInput = ref(false);
const messageReferenceId = ref(0);
const modalIsOpen = ref(false);
const modalType = ref('');
const socket = ref(null);

const access_token = localStorage.getItem(_var.TOKEN);
const account_id = store.state.profile.staff.account_id;
const backend_url = process.env.VUE_APP_URL;

const enableAiButton = computed(() => store.state.profile.enable_ai_button);
const modalTypes = computed(() => _MODAL_TYPE);

const aiCost = computed(() => {
	if (props.monthly) return props.studentId ? 2 : 4;
	return props.studentId ? 1 : 2;
});

const reportApi = computed(() =>
	props.monthly ? $api.monthlyReport : $api.weeklyReport
);

const note = ref(props.noteContent);

watch(
	() => props.noteContent,
	(value) => {
		note.value = value || '';
	}
);

watch(
	() => props.sideOverShow,
	(value) => {
		if (!value) return;
		socket.value?.close();
		loadingInput.value = false;
		disableAi.value = false;
		note.value = props.noteContent || '';
	}
);

function formatNoteForDisplay(text) {
	if (text == null || text === '') return '';
	return String(text)
		.replace(/^###\s+(.*)$/gm, '$1')
		.replace(/\*\*(.*?)\*\*/g, '$1')
		.replace(/^\*\s+/gm, '- ');
}

const displayNote = computed({
	get() {
		return formatNoteForDisplay(note.value);
	},
	set(val) {
		note.value = val;
	},
});

function setupWebSocket() {
	socket.value?.close();

	const socket_url = `${backend_url}/socket/websocket?token=${access_token}&role=teacher`;
	socket.value = new WebSocket(socket_url);

	socket.value.onmessage = (event) => {
		const message = JSON.parse(event.data);
		if (message.payload.data && message.event === 'note_generated') {
			loadingInput.value = false;
			note.value = note.value + message.payload.data;
		}
	};

	socket.value.onopen = () => {
		const joinMessage = {
			topic: `note:${account_id}`,
			event: 'phx_join',
			payload: {},
			ref: messageReferenceId.value++,
		};
		socket.value.send(JSON.stringify(joinMessage));
	};
	socket.value.onerror = (error) => console.error('WebSocket error:', error);
}

async function generateNote() {
	try {
		if (disableAi.value === true) return;
		disableAi.value = true;
		loadingInput.value = true;
		note.value = '';
		setupWebSocket();

		props.studentId
			? await reportApi.value.generateNoteForStudentInGroup(
					props.groupClassId,
					props.reportId,
					props.studentId
			  )
			: await reportApi.value.generateNoteForGroup(
					props.groupClassId,
					props.reportId
			  );
	} catch (e) {
		loadingInput.value = false;
		const error = e?.response?.data?.errors;
		if (error?.error === 'INSUFFICIENT_FUNDS') {
			modalIsOpen.value = true;
			modalType.value = _MODAL_TYPE.INSUFFICIENT_FUNDS;
		} else {
			await store.dispatch('setAlertMessage', {
				message:
					e?.response?.data?.errors?.join('<br/>') ||
					'Đã có lỗi xảy ra. Vui lòng thử lại',
				type: 'danger',
			});
		}
	}
}

onUnmounted(() => {
	socket.value?.close();
});
</script>
<style scoped>
.w-sideover {
	width: 720px;
}
.sideover-content {
	height: calc(100vh - 179px);
	overflow-y: auto;
	padding-bottom: 100px;
}
.note {
	height: calc(100vh - 290px);
}
@media only screen and (max-width: 768px) {
	.w-sideover {
		width: 100%;
	}
}
</style>
